var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.722656 5.05469H15.3477C15.6758 5.05469 15.9414 4.79688 15.9414 4.46875C15.9414 4.14062 15.6758 3.875 15.3477 3.875H0.722656C0.394531 3.875 0.136719 4.14062 0.136719 4.46875C0.136719 4.79688 0.394531 5.05469 0.722656 5.05469ZM0.722656 8.46094H15.3477C15.6758 8.46094 15.9414 8.20312 15.9414 7.875C15.9414 7.53906 15.6758 7.27344 15.3477 7.27344H0.722656C0.394531 7.27344 0.136719 7.53906 0.136719 7.875C0.136719 8.20312 0.394531 8.46094 0.722656 8.46094ZM0.722656 11.875H15.3477C15.6758 11.875 15.9414 11.6094 15.9414 11.2734C15.9414 10.9453 15.6758 10.6875 15.3477 10.6875H0.722656C0.394531 10.6875 0.136719 10.9453 0.136719 11.2734C0.136719 11.6094 0.394531 11.875 0.722656 11.875Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/dragIcon.33306d7b189d262459da6f00485dbef9.svg";
export { ForwardRef as ReactComponent };